export default "__VITE_ASSET__BWigvIqF__"